import { render, staticRenderFns } from "./PCHeader.vue?vue&type=template&id=7de3ff80&scoped=true"
import script from "./PCHeader.vue?vue&type=script&lang=js"
export * from "./PCHeader.vue?vue&type=script&lang=js"
import style0 from "./PCHeader.vue?vue&type=style&index=0&id=7de3ff80&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de3ff80",
  null
  
)

export default component.exports